import React from 'react'
import VehicleBasedIntegrations from '../vehicleBasedIntegrations/VehicleBasedIntegrations'
import { useIntegrationDocsURL } from '../../../../../../utils/docs'

const Kiho: React.FC = () => {
  const integrationDocs = useIntegrationDocsURL()

  return (
    <VehicleBasedIntegrations
      allowAuthentication
      credentialsRequestUrl="/kiho/authentication/{companyId}"
      getVehiclesUrl="/kiho/vehicles/{companyId}"
      updateVehicleUrl="/kiho/vehicles/{companyId}/{id}"
      pageDocsUrl={integrationDocs.external('kiho')}
      name="kiho"
    />
  )
}

export default Kiho
